
import React, { Component } from 'react';
import './energyDeviceChart.less';
import { Checkbox, Input, Select, Button } from "antd";
import PubSub from 'pubsub-js'
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import wifi_4 from "../../../imgs/mesh/wifi_4.png";
import wifi_0 from "../../../imgs/mesh/wifi_0.png";
import btn_left from "../../../imgs/btn/btn_left.png";
import btn_right from "../../../imgs/btn/btn_right.png";
import { deviceNo } from "../../../const/infoConst";
import { searchPower3 } from "../../../utils/net/netManager";
import { bigEndianToLittleEndian, } from '../../../utils/dataUtils';
import { getDeviceInfoByMac, getNameBygroupID } from '../../../utils/deviceUtils';
import { getBleVer, getEnergyGroupArr, getEnergyMeshArr, getIDBygroupName } from '../../../utils/meshUtils';
import { changeEnergySelectBuilding, getEnergyDevicesByGroupId } from '../../../utils/net/netUtils';

let m_model = 0;
let m_status = 0;
export default class EnergyDeviceChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mesh_arr: [], //mesh下拉菜单
            mesh_select: "",

            group_arr: [], //group下拉菜单
            group_select: "",

            list: [
                {
                    'name': 1,
                    'groupIDName': 1,
                    'vid': 1,
                    'power': 1,
                    'groupID': 1,
                }
            ],

            type: 3, //年月日判断3是年 2是月 1是日
            group: '1', //组的编号
            device: '',//单灯的编号
            selectedDate: '2026-02-10',
            zoom: 0,
            currentItems: [],//当前页码的数据
            currentPage: 1,//当前的页码
            totalPages: 0,//所有的页码总数
            itemsPerPage: 10,//每页展示多少数据
        };
    }

    componentDidMount() {
        // 刷新UI
        this.updatePageUI();
        PubSub.subscribe('changeEnergyMeshUpdateUI', (msg, data) => {
            this.updatePageUI();
        })
        PubSub.subscribe('energyDataType', (msg, data) => {
            //0-area  1-group  2-device
        })

        //退出

        this.goToPage(1)
    }

    //刷新UI
    updatePageUI() {
        //mesh
        let name = SPGet("energy_SelectMeshName");
        this.setState({
            mesh_arr: getEnergyMeshArr(),
            mesh_select: name,
        });
        //group
        let arrG = getEnergyGroupArr();
        let groupName = arrG[0].label;
        let groupId = getIDBygroupName(groupName)
        meshLog('groupIdupdatePageUI', groupId);
        SPSet("energy_SelectGroupName", groupName);
        this.setState({
            group_arr: arrG,
            group_select: groupName,
            group: groupId.toString(),
        });
        meshLog('wjk 模拟计量', name, groupName);
        this.getEmerGroupData(groupName);
    }

    //切换mesh下拉菜单
    handleMeshChange = (value) => {
        let name = getEnergyMeshArr()[value].label;
        meshLog('mesh', value, name);
        if (name == SPGet("energy_SelectMeshName")) return;
        let buildname = SPGet("energy_SelectBuildingName");
        changeEnergySelectBuilding(buildname, name);
    };

    //切换group下拉菜单
    handleGroupChange = (value) => {
        let name = getEnergyGroupArr()[value].label;
        meshLog('group', value, name);
        if (name == SPGet("energy_SelectGroupName")) return;

        let groupId = getIDBygroupName(name)
        meshLog('groupIdgroupId', groupId);
        SPSet("energy_SelectGroupName", name);
        //切换group
        this.setState({
            group_select: name,
            group: groupId.toString(),
        });

        this.getEmerGroupData(name);


    };

    //获取刷选组的数据
    getEmerGroupData(name) {
        let lists = JSON.parse(SPGet("energy_groupList"));
        let group = lists.find(item => item.name == name)
        meshLog("profile里group数据:", group);

        setTimeout(() => {
            this.goToPage(1)
        }, 500)


    }

    //获取数据
    goToPage = async (page) => {
        meshLog('当前展示的page', page);

        let group = (this.state.group);
        meshLog('groupgroup', group);
        // 这个组下的所有单灯
        let devices = getEnergyDevicesByGroupId(group)
        meshLog('devicesdevices', devices);

        let emergencyList = getEnergyDevicesByGroupId(group)
        // 计算总页数
        let itemsPerPage = this.state.itemsPerPage
        // meshLog('itemsPerPage', itemsPerPage);
        const totalPages = Math.ceil(emergencyList.length / itemsPerPage);
        // meshLog('totalPages', totalPages);
        let currentPage = page //默认显示第一个页码的数据
        let maxlength
        if (emergencyList.length > currentPage * 10) {
            maxlength = currentPage * 10
        } else {
            maxlength = emergencyList.length
        }

        for (let i = 0; i < emergencyList.length; i++) {
            emergencyList[i] = {
                'name': emergencyList[i].name,
                'groupIDName': getNameBygroupID(emergencyList[i].groupID),
                'vid': getBleVer(emergencyList[i].vid),
                'is_on': (emergencyList[i].is_on),
                'groupID': (emergencyList[i].groupID),
                'macAddress': emergencyList[i].macAddress,
            };

        }
        const currentItems = emergencyList.slice((currentPage - 1) * 10, maxlength);
        meshLog('当前显示的数据', currentItems);
        this.setState({
            currentPage: currentPage,
            totalPages: totalPages,
            currentItems: currentItems,
            list: currentItems,

        })


    };
    // 上一页
    goToPreviousPage = () => {
        if (this.state.currentPage <= 1) {
            return
        } else {
            let currentPage = this.state.currentPage
            this.setState({
                currentPage: currentPage - 1,
            })
            this.goToPage(currentPage - 1);
        }

    };
    // 下一页
    goToNextPage = () => {
        if (this.state.currentPage >= this.state.totalPages) {
            return
        } else {
            let currentPage = this.state.currentPage
            this.setState({
                currentPage: currentPage + 1,
            })
            this.goToPage(currentPage + 1);
        }
    };

    // 返回图表界面
    goToEnergyBarChart = (list) => {
        meshLog('goToEnergyBarChart', list);
        PubSub.publish("goToEnergyBarChart", list);
        //在发送一个控制显示图表界面还是单灯界面
        PubSub.publish("goToEnergyBarChart2", list);

    };

    render() {
        const { dateRange } = this.state;
        return (
            <div className="energyDevice_container">
                {/* 标题行 */}
                <div className="energyDevice-header">
                    <div className="area-tolte">
                        <span  >Energy Data - device</span>
                    </div>
                    <div className="area-select_1">
                        <span className='select_1_title'>Statistics Area</span>
                        <Select
                            className="energy_dropdown_mesh"
                            value={this.state.mesh_select}
                            onChange={this.handleMeshChange}
                            options={this.state.mesh_arr}
                        />
                    </div>

                    <div className="area-select_2">
                        <span className='select_2_title'>Statistics Group</span>
                        <Select
                            className="energy_dropdown_group"
                            value={this.state.group_select}
                            onChange={this.handleGroupChange}
                            options={this.state.group_arr}
                        />
                    </div>

                </div>

                {/* 列表标题 */}
                <div className='energyDevice_title'>
                    <span className='span_1'>Device Name</span>
                    <span className='span_2'>Device Location</span>
                    <span className='span_2'>Version Update </span>
                    <span className='span_1'>Device Status </span>
                    <span className='span_1'>Operation </span>
                </div>
                {/* 列表 */}
                <div className="energyDevicelog_list">
                    {this.state.list.map((list, key) => (
                        <div key={key} className="list_item">
                            <span className='span_1'>{list.name}</span>
                            <span className='span_2'>{list.groupIDName}</span>
                            <span className='span_2'>{list.vid}</span>
                            <span className='span_1'><img className='device_sign' src={list.is_on == 1 ? wifi_4 : wifi_0} /> on-line</span>
                            <div className='span_1' onClick={() => { this.goToEnergyBarChart(list) }} >
                                <button className='span_3'> View chart </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* 底部按钮 */}
                <div className="energyDevice_footer">
                    <span className='info'>Total {this.state.totalPages} Pages</span>
                    <img className='btn_left' onClick={() => { this.goToPreviousPage() }} src={btn_left} />
                    <span className='page'>{this.state.currentPage}</span>
                    <img className='btn_right' onClick={() => { this.goToNextPage() }} src={btn_right} />
                </div>


            </div>

        );
    }
}
